import { Component } from '@angular/core';

@Component({
  selector: 'mprd-user-access-management-skeleton',
  templateUrl: './user-access-management-skeleton.component.html'
})
export class UserAccessManagementSkeletonComponent  {
}
